import AggregateMixin from "csi/action/AggregateMixin";
import AggregateFrom from "csi/table/AggregateFrom";
import NewMixin from "csi/table/NewMixin";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import _ from "lodash";


const SelectCandidateFromStyleController = declare([AggregateFrom, AggregateMixin, NewMixin], {
	/**
	 * @override
	 * Pre-select nodes that correspond to keys already in the key container
	 */
	onFormData(fd): void {
		_.forEach(this._newResultUrls, (url) => {
			const mpv = this.m_cache.getNode(url);
			if (_.includes(mpv.StyleCandidates, this.m_urlParent)) {
				fd.addAggregatedNode(mpv);
			}
		});
	},

	/**
	 * @override
	 * Provide Parameters for SelectCandidateFromStyleCall
	 */
	toWriterRequest(fd): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const nodesRemoved = this._getAggregateRemovals(this.getFormData());
		const removes = !_.isEmpty(nodesRemoved) ? _.map(nodesRemoved, xml.nodeGetURL) : null;
		call.addParameter("AddURLs", xml.ATTR_REFLIST, this.m_formData.getSelectedValue());
		call.addParameter("RemoveURLs", xml.ATTR_REFLIST, removes);
		call.addParameter("Style", xml.ATTR_REF, this.m_urlParent);
		return call;
	},
});

export = SelectCandidateFromStyleController;